import { useMemo } from "react";
import { Provider } from "react-redux";

import AutoPlanContainer from "../containers/AutoPlanContainer";

export default () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  return (
    <Provider store={store}>
      <AutoPlanContainer />
    </Provider>
  );
};
